import { createContext } from 'react';

import { FeatureFlagDto } from '@/api/generated';

export const FeatureFlagsContext = createContext<Set<FeatureFlagDto>>(new Set());
